export default __webpack_public_path__ + "static/media/activity_wifi.cb7f9a16.svg";